import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import { FeedScreen } from '~/components/domain/posts/FeedScreen';
import { feedTypes, type FeedType } from '~/constants/lists';

function parseFromParam(from: unknown): FeedType {
  if (typeof from !== 'string' || from === 'search') return 'global';
  return (feedTypes as readonly string[]).includes(from) ? (from as FeedType) : 'global';
}

export default function SearchFeed() {
  const { from } = useLocalSearchParams<{ from?: string }>();
  const lastUsedFeed = parseFromParam(from);
  return <FeedScreen feedType="search" lastUsedFeed={lastUsedFeed} />;
}
